// extracted by mini-css-extract-plugin
export default {"ProductPrice":"_ProductPrice--w74Da","StrikeThrough":"_StrikeThrough--cxaoL","PriceWithoutDiscount":"_PriceWithoutDiscount--u178m"};